import { cx } from '@linaria/core';
import { useId } from 'react';
import { resets } from '@ui/css';
import { printHtmlNodesToJsx } from '@utils/ast';
import { AudioComponentSelector } from '../index.selectors.js';
import { AudioPlayer } from './molecule.player/_player.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function AudioComponent(props) {
  const id = useId();
  return /*#__PURE__*/jsxs("section", {
    "data-component-type": AudioComponentSelector,
    className: cx("gAudio", resets.rootCls),
    "aria-details": props.transcript && !props.isScrambled ? `transcript-${id}` : undefined,
    "data-scrambled": props.isScrambled,
    children: [/*#__PURE__*/jsx(AudioPlayer, {
      src: props.src,
      caption: props.caption,
      imageSrc: props.imageSrc,
      isScrambled: props.isScrambled
    }), props.transcript && !props.isScrambled && /*#__PURE__*/jsx("aside", {
      className: resets.screenReaderOnlyCls,
      id: `transcript-${id}`,
      "data-disable-polly": true,
      children: /*#__PURE__*/jsx("div", {
        children: printHtmlNodesToJsx(props.transcript)
      })
    })]
  });
}

export { AudioComponent };
//# sourceMappingURL=_audio-component.js.map
